
document.addEventListener('DOMContentLoaded', function() {
     var slider = $('.g-slider').slick({
       centerMode: true,
       centerPadding: '0px',
       slidesToShow: 5,
       infinite: true,
       arrows: true,
       autoplay: true,
       autoplaySpeed: 800,
       cssEase: 'linear',
       draggable:true,
       pauseOnFocus:false,
       pauseOnHover:false,
       responsive: [
   {
   breakpoint: 1200,
   settings: {
     slidesToShow: 3,
     slidesToScroll: 3
   }
   },
   {
   breakpoint: 600,
   settings: {
     slidesToShow: 1,
     slidesToScroll: 1
   }
   },
   {
   breakpoint: 480,
   settings: {
     slidesToShow: 1,
     slidesToScroll: 1
   }
   }
   ]
     });
   
     // Add an event listener for afterChange event
     slider.on('afterChange', function (event, slick, currentSlide) {
       // Set the image source based on the current slide index
       var imageUrl;
       switch (currentSlide) {
         case 0:
         case 5:
           imageUrl = 'https://cdn.shopify.com/s/files/1/0799/9478/1970/files/slider-pastel-red.webp?v=1708947020';
           break;
         case 1:
         case 6:
           imageUrl = 'https://cdn.shopify.com/s/files/1/0799/9478/1970/files/slider-pastel-green.webp?v=1708947028';
           break;
         case 2:
         case 7:
           imageUrl = 'https://cdn.shopify.com/s/files/1/0799/9478/1970/files/slider-pastel-blue.webp?v=1708947012';
           break;
         case 3:
         case 8:
           imageUrl = 'https://cdn.shopify.com/s/files/1/0799/9478/1970/files/slider-pastel-lavender.webp?v=1708947001';
           break;
         case 4:
         case 9:
           imageUrl = 'https://cdn.shopify.com/s/files/1/0799/9478/1970/files/slider-pastel-pink.webp?v=1708946991';
           break;
         default:
           imageUrl = 'default-image-url.jpg'; // Set a default image URL
       }
   
       // Fade out the current image, change the source, and fade in the new image
       $('#s-main-img').fadeOut('', function () {
         $(this).attr('src', imageUrl).fadeIn('');
       });
   
         $('#s-main-img-overlay').attr('src', imageUrl).fadeIn('slow');
   
   
     });

}); 

